export enum CanvasActions {
  Copy = 'duplicate',
  Share = 'share',
  CreateCanvas = 'createCanvas',
  CreateTemplate = 'createTemplate',
  Delete = 'delete',
  Revisions = 'revisions',
  Insights = 'insights',
  Preview = 'preview',
  Edit = 'edit',
  Present = 'present',
}
